module.exports = __webpack_public_path__ + "img/swingLines4.5e7b2b81.png";